module.exports = __webpack_public_path__ + "img/prize-type-4.11bb9eb4.png";